export default "__VITE_ASSET__CyAqDuN7__"